import React from 'react';
import { format } from 'date-fns';
import { PageWrapper } from '../components/layout';
import { KpiStrip, LedgerRiskMatrix, AttentionQueue, Journal } from '../components/dashboard';
import { useAttentionData } from '../hooks/useDashboardQueries';

export const DashboardPage: React.FC = () => {
  const { count, isPending } = useAttentionData();
  const summary = isPending
    ? undefined
    : count > 0
      ? `${count} item${count === 1 ? '' : 's'} need${count === 1 ? 's' : ''} your attention.`
      : 'All quiet in the register.';

  return (
    <PageWrapper
      title="Dashboard"
      subtitle={summary}
      meta={format(new Date(), 'EEEE · MMMM d · yyyy').toUpperCase()}
      noPaper
      maxWidth="xl"
    >
      <KpiStrip />
      <div className="flex flex-col lg:grid lg:grid-cols-[1fr_300px] lg:gap-7">
        <div className="order-2 lg:order-1">
          <AttentionQueue />
          <Journal />
        </div>
        <div className="order-1 mb-6 lg:order-2 lg:mb-0">
          <LedgerRiskMatrix />
        </div>
      </div>
    </PageWrapper>
  );
};
